

export const WIDTH = "1260px";
export const MAX_WIDTH = "calc(100% - 32px)";
export const SECTION_SPACING = "56px";
export const BREAKPOINT = "900px";
export const SECTION_SPACING_2X = "112px";